import React from 'react'
import GatsbyConfig from '../../../gatsby-config.js'
import SiteFooter from '../partials/site-footer'
import HelmetWrapper from '../partials/helmet-wrapper'
import SiteHeader from '../partials/site-header'
import { setInLocal } from '../../utils/app-helpers'

const { siteMetadata: config } = GatsbyConfig

export default class FinalPacketPage extends React.Component {
  componentDidMount() {
    const { trip } = this.props

    setInLocal('lsg.last-viewed-trip', trip)
  }

  render() {
    const { formHash, trip } = this.props
    const tripData = config.trips[trip]
    const title = `${tripData.name} ${tripData.year} | Final Packet`

    return (
      <div className={`page-finaldetails trip-${trip}`}>
        <HelmetWrapper metaTitle={title} />
        <SiteHeader trip={trip} lock readonly />
        <main>
          <h1 className="colorful">
            <div className="content wrap-small lefta">
              LOVESONG | {tripData.name} {tripData.year} |
              Final Packet
            </div>
          </h1>
          <div className="wrap wrap-small">
            <div className="content">
              <p>
                Thank you for submitting you final details! If you purchased
                optional activities, you will be sent an email receipt.
              </p>
              <h2>Very Important</h2>
              <p>
                Please follow the instructions below to view, download, and
                print the LOVESONG | {tripData.name}{' '}
                {tripData.year} | Final Packet PDF. The Final Packet includes a
                letter from Everlasting Tours, Artist &amp; Speaker Bio's,
                Resort &amp; Destination Information, Itinerary, Maps,
                Frequently Asked Questions, Maui Travel Requirements & Safety Protocols, a Packing Check-List, and Everlasting
                Tours On-Location Contact Information. We look forward to seeing
                you in {tripData.name} and know that your marriage will be truly
                blessed through the experience!
              </p>
              <h2>Download Instructions</h2>
              <ol>
                <li>
                  Click the "Download Final Packet" button below (8MB, may take
                  1-2 minutes to download, depending on your connection).
                </li>
                <li>
                  Click File, Save As or Save Page/Link As, and save the Final
                  Packet to your hard drive.
                </li>
                <li>
                  Open the PDF from your hard drive and print a copy (color
                  recommended).
                </li>
                <li>
                  <strong>Bring the Final Packet with you</strong> on LOVESONG | {tripData.name} {tripData.year}.
                </li>
              </ol>
              <blockquote>
                <p>
                  <a
                    className="btn primar"
                    href={`/files/LOVESONG${tripData.name}${
                      tripData.year
                    }FinalPacket.pdf`}
                    target="_blank"
                  >
                    Download Final Packet
                  </a>
                </p>
              </blockquote>
            </div>
          </div>
        </main>
        <SiteFooter trip={trip} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/finalpacket.js